import axios from "axios";
import actions from "./action_types";
import mutations from "./mutation_types";

export default {
    [actions.SAVE_INTERVALS_SETTINGS]: function(store, input_data) {
        store.commit(mutations.SET_INTERVALS_SETTINGS, input_data);
        axios.post('/summaries/receivables-and-liabilities/settings/save', input_data)
            .then(response => {
                toastr['success'](response.data.message).css('border', '0px')
            }).catch(error => {
                toastr['error'](error.response.data.message).css('border', '0px')
            })
    },
    [actions.INIT_INTERVALS_SETTINGS]: function(store, settings) {
        store.commit(mutations.SET_INTERVALS_SETTINGS, settings);
    },
    [actions.SAVE_CURRENCY]: function(store, input) {
        store.commit(mutations.SET_CURRENCY, input);
    },
    [actions.SAVE_DATE]: function(store, input) {
        store.commit(mutations.SET_DATE, input);
    },
    [actions.ADD_TO_SELECTED]: function(store, idsArray) {
        store.commit(mutations.PUSH_TO_SELECTED, idsArray);
    },
    [actions.REMOVE_FROM_SELECTED]: function(store, id) {
        store.commit(mutations.SHIFT_FROM_SELECTED, id);
    },
    [actions.DELETE_ALL_SELECTED]: function(store) {
        store.commit(mutations.CLEAR_SELECTED);
    }
}